import { Link } from "react-router-dom";
import { Compass, ArrowRight } from "lucide-react";
import { PublicNav, PublicFooter } from "./Marketing";
import Seo from "../components/Seo";

const LINKS = [
  ["Home", "/"],
  ["Pricing", "/pricing"],
  ["Features", "/features"],
  ["Industries", "/industries"],
  ["Book a demo", "/book-demo"],
  ["Start free trial", "/onboarding"],
];

export default function NotFound() {
  return (
    <div className="min-h-screen bg-slate-950 text-white flex flex-col" data-testid="not-found-page">
      <Seo title="Page not found" path="" noindex />
      <PublicNav />
      <main className="flex-1 max-w-3xl mx-auto px-6 py-24 text-center">
        <div className="inline-flex items-center justify-center h-14 w-14 rounded-2xl bg-amber-500/10 border border-amber-500/30 mb-6">
          <Compass className="h-7 w-7 text-amber-400" />
        </div>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight" data-testid="not-found-title">
          This page took a wrong turn.
        </h1>
        <p className="text-slate-400 mt-4 max-w-lg mx-auto">
          The page you were looking for doesn't exist or has moved. Here's where most people head next.
        </p>
        <div className="grid sm:grid-cols-2 gap-3 mt-10 text-left">
          {LINKS.map(([label, to]) => (
            <Link key={to} to={to} data-testid={`not-found-link-${to.replace(/\//g, "") || "home"}`}
              className="flex items-center justify-between p-4 rounded-xl bg-slate-900 border border-slate-800 hover:border-amber-500/50 transition-colors group">
              <span className="font-semibold group-hover:text-amber-400 transition-colors">{label}</span>
              <ArrowRight className="h-4 w-4 text-slate-500 group-hover:text-amber-400 transition-colors" />
            </Link>
          ))}
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
